module.exports = __webpack_public_path__ + "static/media/icons-alt.f519d8e6.svg";